import { Modal } from 'antd';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../../hooks/useMainContext';
import { PdfIcon, SpaceIcon } from '../../Globle/Icon';
import { useState } from 'react';
import Button from '../../Globle/Button';

const StartingPointModel = observer(() => {
    const { uiManager } = useMainContext();
    const [selectedOption, setSelectedOption] = useState(null);
    const cardOptions = [
        {
            icon: <PdfIcon />,
            title: 'From Blueprints',
            subtext:
                'Upload a PDF of your architectural plans and map out the designs to generate your quote.',
            onclick: () => {
                setSelectedOption('pdf');
            },
            key: 'pdf',
        },
        {
            icon: <SpaceIcon />,
            title: 'Design your Space',
            subtext:
                "Don't have plans? Enter your best measurements for an estimated quote.",
            onclick: () => {
                setSelectedOption('space');
            },
            key: 'space',
        },
    ];
    const handleConfirm = () => {
        if (selectedOption === 'pdf') {
            uiManager.setIsPdfUploadModel(true);
        }
        setSelectedOption(null);
        uiManager.setIsStartingPoint(false);
    };
    return (
        <Modal
            footer={null}
            centered
            width={800}
            open={uiManager.isStartingPoint}
            styles={{
                content: {
                    padding: '32px',
                    borderRadius: '32px',
                },
            }}
            onCancel={() => {
                setSelectedOption(null);
                uiManager.setIsStartingPoint(false);
            }}>
            <h1 className="font-favorit text-[32px] font-[700] leading-[40px]">
                Select your starting point
            </h1>
            <div className="grid grid-cols-2 gap-4 mt-[32px]">
                {cardOptions.map((card, index) => {
                    return (
                        <div
                            key={index}
                            style={{
                                backgroundColor:
                                    selectedOption === card.key
                                        ? '#000000'
                                        : '#F5F5F5',
                                color:
                                    selectedOption === card.key
                                        ? '#fff'
                                        : '#000',
                            }}
                            onClick={card.onclick}
                            className="flex gap-[16px] flex-col items-center h-[248px] p-[32px] rounded-[16px] cursor-pointer">
                            <div className="flex justify-center items-center h-[80px] w-[80px] bg-theme-white rounded-full">
                                {card.icon}
                            </div>
                            <h1 className="font-favorit text-[20px] font-[700] leading-[28px]  text-center">
                                {card.title}
                            </h1>
                            <p className="font-favorit text-[14px] font-[400] leading-[20px]  text-center">
                                {card.subtext}
                            </p>
                        </div>
                    );
                })}
            </div>
            <div className="mt-[32px] flex justify-end ">
                <Button
                    label={'Confirm'}
                    onClick={handleConfirm}
                    className={` ${!selectedOption ? 'pointer-events-none !bg-[#F5F5F5] !text-[#CCCCCC]' : 'bg-theme-orange text-theme-white hover:bg-theme-orange-hover'}`}
                />
            </div>
        </Modal>
    );
});

export default StartingPointModel;
